import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	tableCaptionAllProjects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionAllProjectsAndAllCategories: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionSpecificProduct: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionSpecificCategory: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionSpecificProductAllCategories: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionSpecificProductSpecificCategories: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionAllProjectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionAllProjectsAndAllCategoriesGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionSpecificProductGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionSpecificCategoryGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionSpecificProductAllCategoriesGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tableCaptionSpecificProductSpecificCategoriesGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	tableCaptionAllProjects: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects',
		defaultMessage: 'Table showing all projects',
		description: 'Projects table caption text',
	},
	tableCaptionAllProjectsAndAllCategories: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects-and-all-categories',
		defaultMessage: 'Table showing all projects for all categories.',
		description: 'Projects table caption text for all categories',
	},
	tableCaptionSpecificProduct: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product',
		defaultMessage: 'Table showing {product} projects.',
		description: 'Projects table caption text for specific products',
	},
	tableCaptionSpecificCategory: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-category',
		defaultMessage: 'Table showing all projects for {category} category',
		description: 'Projects table caption text for specific products',
	},
	tableCaptionSpecificProductAllCategories: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-all-categories',
		defaultMessage: 'Table showing {product} projects for all categories',
		description: 'Projects table caption text for specific products for all categories',
	},
	tableCaptionSpecificProductSpecificCategories: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-specific-categories',
		defaultMessage: 'Table showing {product} projects for {category} category',
		description: 'Projects table caption text for specific products for all categories',
	},
	tableCaptionAllProjectsGalaxia: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects-galaxia',
		defaultMessage: 'Table showing all spaces',
		description: 'Projects table caption text',
	},
	tableCaptionAllProjectsAndAllCategoriesGalaxia: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects-and-all-categories-galaxia',
		defaultMessage: 'Table showing all spaces for all categories.',
		description: 'Projects table caption text for all categories',
	},
	tableCaptionSpecificProductGalaxia: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-galaxia',
		defaultMessage: 'Table showing {product} spaces.',
		description: 'Projects table caption text for specific products',
	},
	tableCaptionSpecificCategoryGalaxia: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-category-galaxia',
		defaultMessage: 'Table showing all spaces for {category} category',
		description: 'Projects table caption text for specific products',
	},
	tableCaptionSpecificProductAllCategoriesGalaxia: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-all-categories-galaxia',
		defaultMessage: 'Table showing {product} spaces for all categories',
		description: 'Projects table caption text for specific products for all categories',
	},
	tableCaptionSpecificProductSpecificCategoriesGalaxia: {
		id: 'projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-specific-categories-galaxia',
		defaultMessage: 'Table showing {product} spaces for {category} category',
		description: 'Projects table caption text for specific products for all categories',
	},
});
export default messages;
